module.exports = __webpack_public_path__ + "img/handbag-fill.2e0436df.svg";